import { Link, usePathname } from '@/i18n/navigation';
import { useTranslations } from 'next-intl';
import { NAVIGATION_ITEM_CLASS, NAVIGATION_LAST_ITEM_CLASS, NavigationDropDown } from './navigation-dropdown';

type Props = {
    isActive?: boolean;
};

const activeItemClass =
    'whitespace-nowrap flex items-center gap-2 rounded-[8px] p-[10px] my-2 relative w-full text-left text-base bg-[#DD06AE]';

export const BuyerSellerDropDown = ({ isActive }: Props) => {
    const t = useTranslations('Navigation');
    const pathname = usePathname();

    return (
        <NavigationDropDown label={t('buyerOrSeller')} isActive={isActive}>
            {(close) => (
                <>
                    <li>
                        <Link
                            className={pathname.includes('/tv-rights-buyers') ? activeItemClass : NAVIGATION_ITEM_CLASS}
                            href="/tv-rights-buyers"
                            onClick={close}
                        >
                            {t('tvRightsBuyers')}
                        </Link>
                    </li>
                    <li>
                        <Link
                            className={`${pathname.includes('/tv-rights-sellers') ? activeItemClass : NAVIGATION_ITEM_CLASS} ${NAVIGATION_LAST_ITEM_CLASS}`}
                            href="/tv-rights-sellers"
                            onClick={close}
                        >
                            {t('tvRightsSellers')}
                        </Link>
                    </li>
                </>
            )}
        </NavigationDropDown>
    );
};
